import { type } from 'os';
import { ActionExtended } from '../../../_common/interfaces/ActionExtended';
import { ACTIONS } from '../../../_config'

export interface LoaderReducer {
  fpLoaderShown: boolean;
  sidebar: boolean;
}

const initialState: LoaderReducer = {
  fpLoaderShown: false,
  sidebar: true,
};

const loaderReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.LOADER.SET_FP_STATUS:
      return {
        ...state,
        fpLoaderShown: action.payload,
      };
    case ACTIONS.LOADER.SET_SIDEBAR:
      return {
        ...state,
        sidebar: action.payload.sidebar,
      };
    default:
      return state;
  }
};

export default loaderReducer;
